import FormattedMessage from 'I18n/components/FormattedMessage';
import { Button } from 'foundations-components/transitional/components/Button';
import { DialogBody } from 'foundations-components/transitional/components/DialogBody';
import { DialogFooter } from 'foundations-components/transitional/components/DialogFooter';
import { DialogHeader } from 'foundations-components/transitional/components/DialogHeader';
import { Modal } from 'foundations-components/transitional/components/Modal';
import { Text } from 'foundations-components/components/Text';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const DeleteAttachmentModal = ({
  onConfirm,
  onReject
}) => {
  return /*#__PURE__*/_jsxs(Modal, {
    use: "danger",
    children: [/*#__PURE__*/_jsx(DialogHeader, {
      children: /*#__PURE__*/_jsx(Text, {
        as: "h5",
        children: /*#__PURE__*/_jsx(FormattedMessage, {
          message: "composer-ui.attachment.delete-attachment-modal.title"
        })
      })
    }), /*#__PURE__*/_jsx(DialogBody, {
      children: /*#__PURE__*/_jsx(FormattedMessage, {
        message: "composer-ui.attachment.delete-attachment-modal.message"
      })
    }), /*#__PURE__*/_jsxs(DialogFooter, {
      children: [/*#__PURE__*/_jsx(Button, {
        onClick: onConfirm,
        use: "danger",
        children: /*#__PURE__*/_jsx(FormattedMessage, {
          message: "composer-ui.attachment.delete-attachment-modal.confirm-button-text"
        })
      }), /*#__PURE__*/_jsx(Button, {
        onClick: onReject,
        children: /*#__PURE__*/_jsx(FormattedMessage, {
          message: "composer-ui.attachment.delete-attachment-modal.cancel-button-text"
        })
      })]
    })]
  });
};
DeleteAttachmentModal.displayName = 'DeleteAttachmentModal';
export default DeleteAttachmentModal;